export var getValueFromVariables = function (variables, key) {
    var _a;
    return (_a = variables === null || variables === void 0 ? void 0 : variables.settings) === null || _a === void 0 ? void 0 : _a.find(function (setting) { return setting.key === key; });
};
